import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { map } from 'rxjs/operators'
import { productSelectors } from './../../product/product.selectors'
import { Product } from './../../product/product'
import { roleSelectors } from './../../role/role.selectors'
import { Role } from './../../role/role'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { RolePermissions } from './../role-permissions'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { NotificationService } from 'src/app/core/notification.service'
import { scrollToFirstInvalidControl } from 'src/app/shared/until'
import moment from 'moment-mini'
import { productActions } from '../../product/product.actions'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'

@Component({
  selector: 'role-permissions-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class RolePermissionsFormComponent implements OnInit {
  @Output()
  onSubmit = new EventEmitter<any>()
  @Input()
  rolePermissions: RolePermissions
  public accessRights = AccessRights

  public form: UntypedFormGroup
  public roles$: Observable<Role[]>
  public products$: Observable<Product[]>

  public selectedRoleId: any

  constructor(
    private fb: UntypedFormBuilder,
    private elementRef: ElementRef,
    private notificationService: NotificationService,
    private store: Store
  ) {}
  ngOnInit() {
    this.roles$ = this.store.select(roleSelectors.selectAll)

    this.products$ = this.store.select(productSelectors.selectAll).pipe(
      map((products) => {
        return products.filter((product) => {
          return product.allowAsLinkedProduct && Boolean(product.isActive)
        })
      })
    )

    this.form = this.fb.group({
      roleId: [null, [Validators.required]],
      productId: [[], [Validators.required]],
      validFrom: [
        null,
        [Validators.required, Validators.minLength(1), Validators.maxLength(32)]
      ],

      validTill: [
        null,
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(255)
        ]
      ]
    })
    if (this.rolePermissions) {
      if (this.rolePermissions.roleId) {
        this.form.controls.roleId.patchValue(this.rolePermissions.roleId)
        this.selectedRoleId = this.rolePermissions.roleId
      }
      if (this.rolePermissions.productId) {
        this.form.controls.productId.patchValue(this.rolePermissions.productId)
      }
    }
  }

  onFormSubmit() {
    let errorDate = false
    if (!moment(new Date(this.form.controls['validFrom'].value)).isValid()) {
      this.form.controls['validFrom'].setErrors({ invalidDate: true })
    }
    if (!moment(new Date(this.form.controls['validTill'].value)).isValid()) {
      this.form.controls['validTill'].setErrors({ invalidDate: true })
    }
    if (
      moment(new Date(this.form.controls['validTill'].value)).isValid() &&
      moment(new Date(this.form.controls['validFrom'].value)).isValid() &&
      moment(new Date(this.form.controls['validFrom'].value)).isAfter(
        moment(new Date(this.form.controls['validTill'].value))
      )
    ) {
      this.form.controls['validTill'].setErrors({ invalidDate: true })
      errorDate = true
    }
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })
      if (errorDate) {
        this.notificationService.emit('general.incorrectEndDate', 'warning')
      } else {
        scrollToFirstInvalidControl(this.elementRef, this.notificationService)
      }

      console.log('%cForm is invalid', 'color: red; font-weight: bold;')
      return
    }

    const entities = []

    if (Array.isArray(this.form.value.productId)) {
      this.form.value.productId.forEach((pId) => {
        entities.push({ ...this.form.value, productId: pId })
      })
    } else {
      entities.push(entities.push(this.form.value))
    }

    this.onSubmit.emit(entities)
  }
  public onSearchProducts(term: string) {
    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            description: { [CondOperator.CONTAINS_LOW]: term }
          }
        })
      })
    )
  }
}
